"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePatchConsumerV2ReceiptsReceiptUuidSignMutation = exports.useLazyGetConsumerV2ReceiptsReceiptUuidQuery = exports.useGetConsumerV2ReceiptsReceiptUuidQuery = exports.usePostConsumerV2AuthValidateMutation = exports.consumerApplicationsApi = void 0;
const consumerApiSlice_1 = require("../consumerApiSlice");
const injectedRtkApi = consumerApiSlice_1.api.injectEndpoints({
    endpoints: (build) => ({
        postConsumerV2AuthValidate: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/auth/validate`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getConsumerV2ReceiptsReceiptUuid: build.query({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}`,
            }),
        }),
        patchConsumerV2ReceiptsReceiptUuidSign: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/sign`,
                method: 'PATCH',
                body: queryArg.body,
            }),
        }),
    }),
    overrideExisting: false,
});
exports.consumerApplicationsApi = injectedRtkApi;
exports.usePostConsumerV2AuthValidateMutation = injectedRtkApi.usePostConsumerV2AuthValidateMutation, exports.useGetConsumerV2ReceiptsReceiptUuidQuery = injectedRtkApi.useGetConsumerV2ReceiptsReceiptUuidQuery, exports.useLazyGetConsumerV2ReceiptsReceiptUuidQuery = injectedRtkApi.useLazyGetConsumerV2ReceiptsReceiptUuidQuery, exports.usePatchConsumerV2ReceiptsReceiptUuidSignMutation = injectedRtkApi.usePatchConsumerV2ReceiptsReceiptUuidSignMutation;
